
import {ref} from 'vue'
export default {
    props:{
       updateValue:{
           type:Function,
           default:()=>{
           }
       },
       onSearchValue:{
         type:Function,
         default:()=>{
         }
       }
    },
   setup(props:any,{emit}:any){
       let search = ref()
       //模糊搜素
     const onUpdate = ()=>{
         emit('updateValue',search.value)     
     }
     //确定键搜索
      const onSearch = ()=>{
        emit('onSearchValue',search.value)
      }
     return {
         onSearch,
         onUpdate,
         search
     }
   }
}
